var map = {
	"./01 dj.jpg": 155,
	"./02 alcove.jpg": 538,
	"./03 fresque.jpg": 906,
	"./04 food.jpg": 371,
	"./05 cocktails.jpg": 866,
	"./06 bières.jpg": 922,
	"./07 staff.jpg": 797,
	"./08 exter.jpg": 242,
	"./09 events .jpg": 416,
	"./10 planche.jpg": 755,
	"./11 ambiance.jpg": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;